import { OrderAdDetail } from "@core/models/order-ad-detail.model";
import { Subject } from "rxjs";
import { MaterialPreviewDialogResult } from "./material-preview-dialog-result";

export class MaterialPreviewDialogParams {
	readonly orderAdDetail: OrderAdDetail;
	readonly orderId: string;
	readonly advertiserId: string;

	readonly newMaterialUploadedReporter: Subject<MaterialPreviewDialogResult> | undefined;
	//readonly index: number;

	//constructor (orderAdDetail: OrderAdDetail, orderId: string, advertiserId: string, index: number) {
	//	this.orderAdDetail = orderAdDetail;
	//	this.orderId = orderId;
	//	this.advertiserId = advertiserId;
	//	this.index = index;
	//}

	useExternalMaterialUploader: boolean = false;

	constructor (orderAdDetail: OrderAdDetail, orderId: string, advertiserId: string, newMaterialUploadedReporter: Subject<MaterialPreviewDialogResult> | undefined = undefined) {
		this.orderAdDetail = orderAdDetail;
		this.orderId = orderId;
		this.advertiserId = advertiserId;
		this.newMaterialUploadedReporter = newMaterialUploadedReporter;
	}
}

